import { useEffect, useState } from 'react';
import { useWhiteboardStore } from '../store/useWhiteboardStore';
import { cleanupRecordingLocalStorage, getLocalStorageSize, formatBytes } from '../utils/localStorageCleanup';

export const useRecordingInit = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { recordings } = useWhiteboardStore();

  useEffect(() => {
    // Clean up old recording data from localStorage and initialize
    if (!isLoaded) {
      // Log current localStorage usage before cleanup
      const sizeBefore = getLocalStorageSize();
      
      // Clean up old recording entries
      cleanupRecordingLocalStorage();
      
      // Log size after cleanup
      const sizeAfter = getLocalStorageSize();
      
      setIsLoaded(true);
    }
  }, [isLoaded]);

  return recordings;
};